<template>
  <div
    class="button-dropdown"
    :class="{ '-show-menu': this.showMenu }"
  >
    <button
      :class="['btn', `btn-${color}`, ...variantClass]"
      @click="showMenu = !showMenu"
    >
      <slot name="button-content"></slot>
    </button>
    <div class="menu">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonDropdown',

  props: {
    color: {
      type: String,
      required: true,
      default: 'primary',
    },
    variant: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      showMenu: false,
    };
  },

  methods: {
    /**
     * Check if element are inside the dropdown.
     *
     * @param el
     * @returns {boolean}
     */
    elementAreInsideDropdown(el) {
      try {
        let node = el.parentNode;

        while (node != null) {
          if ((node.className || '').indexOf('button-dropdown') > -1) {
            return true;
          }

          node = node.parentNode;
        }

        return false;
      } catch {
        return false;
      }
    },

    /**
     * Check if element are a user menu link.
     *
     * @param el
     * @returns {boolean}
     */
    elementAreAMenuLink(el) {
      try {
        if ((el.className || '').indexOf('item--link') > -1) {
          return true;
        }

        let node = el.parentNode;
        while (node != null) {
          if ((node.className || '').indexOf('item--link') > -1) {
            return true;
          }

          node = node.parentNode;
        }

        return false;
      } catch {
        return false;
      }
    },
  },

  computed: {
    /**
     * Variant class to button.
     */
    variantClass() {
      return this.variant
        .split(' ')
        .map((variant) => `-${variant}`)
        .join(' ');
    },
  },

  mounted() {
    document.addEventListener('click', ({ target }) => {
      if (!this.showMenu) {
        return;
      }

      const elementAreInsideDropdown = this.elementAreInsideDropdown(target);
      const elementAreAMenuLink = this.elementAreAMenuLink(target);

      if (!elementAreInsideDropdown || (elementAreInsideDropdown && elementAreAMenuLink)) {
        this.showMenu = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
  .button-dropdown {
    position: relative;

    .btn {
      outline: none;

      &:after {
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: .355em;
        position: relative;
        top: 1px;
        vertical-align: .255em;
        content: "";
        border-top: .3em solid;
        border-right: .3em solid transparent;
        border-bottom: 0;
        border-left: .3em solid transparent;
      }
    }

    .menu {
      @apply mt-2;
      @apply py-2;
      @apply bg-white;
      @apply rounded-lg;
      @apply shadow-xl;
      @apply absolute;
      display: none;
      right: 0;
      min-width: 200px;
    }

    &.-show-menu {
      .btn {
        &:after {
          transform: rotateX(180deg);
        }
      }

      .menu {
        display: block;
      }
    }
  }
</style>
